import { useTranslation } from '@dagens/frontend-i18n';
import styled from 'styled-components';
import CalendarMonths from './CalendarMonths';
import Typography from '@carrot-deprecated/typography';
import Container from '@carrot-deprecated/container';
import Theme from '@carrot-deprecated/theme';
import { SeasonCalendar } from 'types/Product';
import {
  calculatePeriodPosition,
  isAlwaysInSeason,
  isValidThisYear
} from 'utils/season';

const CalendarContainer = styled.div`
  position: relative;
  width: 100%;
  height: ${Theme.Spacings.m}px;
`;

const InSeasonBlock = styled.div<{ width: string; left: string }>`
  position: absolute;
  left: ${({ left }) => {
    return left;
  }};
  width: ${({ width }) => {
    return width;
  }};
  height: inherit;
  background-color: ${Theme.Colours.availability};
  border-radius: ${Theme.BorderRadius.regular}px;
`;

type SingleProductSeasonProps = {
  seasonCalendar: SeasonCalendar;
};

const SingleProductSeason = ({
  seasonCalendar = []
}: SingleProductSeasonProps) => {
  const { t } = useTranslation();
  return (
    <Container mt="s">
      <Typography variant="paragraphSmall" mb="s">
        {t('producer:productSeasonCalendarYear')}
      </Typography>
      <CalendarContainer>
        {isAlwaysInSeason(seasonCalendar) ? (
          <InSeasonBlock left="0%" width="100%" />
        ) : (
          seasonCalendar.filter(isValidThisYear).map(period => {
            const { left, width } = calculatePeriodPosition(period);
            return (
              <InSeasonBlock key={period._key} left={left} width={width} />
            );
          })
        )}
        <CalendarMonths />
      </CalendarContainer>
    </Container>
  );
};

export default SingleProductSeason;
